import React, { useState, useEffect } from 'react';
import { lazyLoadOffset, isLinesOnboardingPage } from '../../../../utils';
import { useLinesContext } from '../../../../contexts/Lines';
import { Color } from '../../../../themes/styles';
import cloneDeep from 'lodash.clonedeep';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DividerHorizontal from '../../Misc/DividerHorizontal';
import StageName from './StageName';
import StageAmount from './StageAmount';
import StageDate from './StageDate';
import StageTabs from './StageTabs';
import moment from 'moment';
import LazyLoad from 'react-lazyload';
import StagePlaceHolder from '../../Placeholders/StagePlaceholder';

const useStyles = makeStyles((theme: any) => ({
  stage: { width: '100%' },
  stageContent: {
    textAlign: 'center',
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  stageDetails: {
    position: 'relative',
    color: theme.palette.brand.greenDark,
    width: '100%',
    fontWeight: 500,
    '& .MuiInputBase-input': {
      color: theme.palette.brand.greenDark,
      fontWeight: 500,
      fontSize: isLinesOnboardingPage(window.location.pathname) ? 13 : 12,
      padding: 0,
      paddingBottom: theme.spacing(0.5),
    },
  },
  stageDetail: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function Stage({
  line,
  stages: stagesInMonth,
  handleStageUpdate,
  addOrDeleteError,
  setAutoSave = (arg) => {},
}) {
  const classes = useStyles();
  const { editLineClick } = useLinesContext();
  const { lineOnEditMode: someLineEdited } = useLinesContext();

  const [stages, setStages] = useState(cloneDeep(stagesInMonth));
  const [currentStageToShow, setCurrentStageToShow] = useState(null);
  let stage = stages?.find((stage) => stage.show);
  if (!stage) {
    stage = stages[0];
  }

  function handleStageToShow(id: string) {
    const stagesCopy = cloneDeep(stages);
    setCurrentStageToShow(id);
    const updatedStages = stagesCopy.map((stage) => {
      stage['show'] = stage.id === id ? true : false;
      return stage;
    });
    setStages(updatedStages);
  }

  useEffect(() => {
    const stagesCopy = cloneDeep(stagesInMonth);
    const stageToShowExists = stagesCopy.find(
      (stage) => stage.id === currentStageToShow,
    );
    const updatedStages = stagesCopy.map((stage, i) => {
      if (!stageToShowExists) {
        stage['show'] = i === 0 ? true : false;
      } else {
        stage['show'] = currentStageToShow === stage.id ? true : false;
      }
      return stage;
    });
    setStages(updatedStages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stagesInMonth]);

  const isStages = stages.length > 0;

  let editMode = line.edit;
  if (line.editRightSide) {
    editMode = moment(stage?.start).isAfter(moment());
  }

  return (
    <div
      className={classes.stage}
      onClick={() => {
        if (!isStages) {
          editLineClick(line);
        }
      }}
    >
      {isStages && (
        <LazyLoad offset={lazyLoadOffset}>
          <StageTabs
            line={line}
            stages={stages}
            editMode={editMode}
            handleStageToShow={handleStageToShow}
            handleStageUpdate={handleStageUpdate}
          />
        </LazyLoad>
      )}
      <div
        className={classes.stageContent}
        onClick={() => !someLineEdited && editLineClick(line)}
      >
        {isStages && (
          <>
            <LazyLoad
              offset={lazyLoadOffset}
              placeholder={<StagePlaceHolder />}
            >
              <StageName
                stage={stage}
                handleStageUpdate={handleStageUpdate}
                edit={editMode}
                setAutoSave={setAutoSave}
              />
              <div className={classes.stageDetails}>
                <div className={classes.stageDetail}>
                  <StageAmount
                    stage={stage}
                    edit={editMode}
                    handleStageUpdate={handleStageUpdate}
                    addOrDeleteError={addOrDeleteError}
                  />
                </div>
                <DividerHorizontal margin={0.5} color={Color.GREY_LIGHT} />
                <div className={classes.stageDetail}>
                  <StageDate
                    stage={stage}
                    edit={editMode}
                    handleStageUpdate={handleStageUpdate}
                    addOrDeleteError={addOrDeleteError}
                    setAutoSave={setAutoSave}
                  />
                </div>
              </div>
            </LazyLoad>
          </>
        )}
      </div>
    </div>
  );
}
